import Mousetrap from "mousetrap";
import diffFiles from "./diffs";
import Tabs from "./tabs";
import "../../node_modules/nouislider/distribute/nouislider.css";
import noUiSlider from "nouislider";
export default function() {
  this.component = {
    async: false,
    key: null,
    session: null,
    id: null,
    stack: null,
    editor: null
  };
  let component = this.component;
  let diff = new diffFiles();
  let asyncPending = false;
  let that;
  let JSONData;
  let session;
  this.component.init = function(node) {
    let fileType = node.data.file_type || node.fileType;
    let secure_random = node.data.secure_random;
    let tephra = node.data.tephra;
    component.node = node;
    component.key = node.data.secure_random;
    that = this;
    if ($("#file-history").length > 0 || asyncPending) {
      this.reinstance(node);
    } else {
      let notification = CodeEditor.UI.notif();
      notification({ message: "Retrieving history...", timeout: 100000 });
      JSONData = $.ajax({
        type: "GET",
        url: "/api/v1/code_editor/file_history.json?",
        data: {
          theme_id: CodeEditor.Main.themeId(),
          file_type: fileType,
          secure_random: tephra ? secure_random.replace(/-liquid|-js|-scss/g, "") : secure_random,
          socket_id: window.socketId
        },
        beforeSend: () => {
          asyncPending = true;
          component.async = true;
          console.log("beforeSend");
        }
      });

      JSONData.done(function(data) {
        asyncPending = false;
        component.async = false;
        if (data.length === 0) {
          notification.destroy();
          // notification.warning('history retrieved successfully, but it\'s empty! ')
          notification.warning({ message: "history retrieved successfully, but it's empty!", timeout: 2000 });
        } else {
          notification.destroy();
          // notification.success('history retrieved successfully!')
          notification.success({ message: "history retrieved successfully!", timeout: 2000 });
          // notification.destroy(1500);
          CodeEditor.Tree.openFile(null, node, () => {
            const raw_body_key = component.raw_body_label(node);
            component.tab = Tabs.getTabByKey(component.key);
            component.editor = window.editor;
            CodeEditor.Main.disableEditor();
            session = window.aceSessions["session_" + component.tab.config.key];
            session.originalBody = session.getValue();
            data = data.reverse();
            window.data = data;
            let file_history_ui = new that.uiController();
            file_history_ui.addTo(".page-container");
            const container = $("<div id='slider'></div>").appendTo($("#file-history"))[0];
            $("#file-history").append('<div id="restore-point-tooltip"/>');
            $("#restore-point-tooltip").css({
              bottom: "4px",
              position: "absolute",
              zIndex: 1,
              left: "50%",
              transform: "translate(-50%, 0px)"
            });
            noUiSlider.create(container, {
              start: data.length,
              step: 1,
              behaviour: "tap",
              connect: [true, false],
              range: {
                min: 0,
                max: data.length
              }
            });
            container.noUiSlider.on("slide", (values, handle, [value]) => {
              value = Math.round(value); // sometimes the vlaue will have a decimal point
              session.setValue(session.originalBody);
              diff.init(session.originalBody, data[0][raw_body_key], {
                session: session,
                editor: component.editor
              });
              if (value === data.length) {
                // first item in history
                $("#restore-point-tooltip").html("Current");
              } else if (value === 0) {
                // last item in history
                console.log("last item in history");
                const [current_object] = data;
                const { owner_name, updated_at } = current_object;
                const current_body = current_object[raw_body_key] ?? "";
                session.setValue(current_body);
                diff.removeMarkers();
                $("#restore-point-tooltip").html(`${new Date(updated_at).toString()} by ${owner_name ?? "Unknown"}`);
                file_history_ui.addRevertBtn(current_object);
              } else {
                const { [raw_body_key]: prev_body = "" } = data[value];
                const current_tyimestamp_data = data[value - 1];
                const { owner_name, updated_at, [raw_body_key]: current_body = "" } = current_tyimestamp_data;
                session.setValue(current_body);
                diff.init(prev_body, current_body, { session, editor: component.editor });
                file_history_ui.addRevertBtn(current_tyimestamp_data);
                $("#restore-point-tooltip").html(`${new Date(updated_at).toString()} by ${owner_name ?? "Unknown"}`);
              }
            });

            file_history_ui.refreshView();
            file_history_ui.addRevertBtn();
            //  data.forEach(file_history_ui.addRestorPoint)
          });
        }
      });
      JSONData.fail(err => {
        console.error(err);
        asyncPending = false;
        component.async = false;
        notification.error({
          message: "Failed to retrieve this file's history, check console for errors!",
          timeout: 1500
        });
        // notification.error('Failed to retrieve this file\'s history, check console for errors!')
        // notification.destroy(1500)
      });
    }
  };
  // UI STUFF
  this.component.uiController = function() {
    this.addTo = function(selector) {
      $(selector).prepend('<div id="file-history"/>');
      $("#file-history").append('<button id="file-history-close-button">close</button>');

      $("#file-history-close-button").click(function() {
        that.close();
        $("#file-history-close-button").off("click");
      });
      Mousetrap($("#file-history")[0]).bind(["esc", "escape"], function() {
        that.close();
      });
    };
    this.refreshView = function() {
      if ($("#file-history-info").length === 0) {
        $('<div id="file-history-info"></div>').appendTo("#file-history");
      }
      $(".editor-wrapper").css("height", "calc( 100vh - " + $("#file-history").outerHeight(true) + "px )");
      Panes.updateSize();
    };
    // restore points
    this.addRestorPoint = function(restore_point) {
      let date = new Date(restore_point.updated_at);
      $("#file-history-info").prepend(
        '<div id="restore_point-' +
          date.getTime() +
          '" class="restore-point hidden">' +
          date.toGMTString() +
          " by " +
          restore_point.owner_name +
          "</div>"
      );
    };
    this.hideRestorePoints = function() {
      $("#file-history .restore-point").addClass("hidden state-inactive");
      this.refreshView();
    };
    this.showRestorePoint = function(restore_point) {
      this.hideRestorePoints();
      $("#restore_point-" + new Date(restore_point.updated_at).getTime())
        .removeClass("hidden state-inactive")
        .addClass("state-active");
      this.refreshView();
    };
    // Buttons
    this.addRevertBtn = function(restore_point) {
      $("#file-history-revert").off("click");
      if ($("#file-history-revert").length == 0) {
        $("#file-history-info").append(
          '<button id="file-history-revert" class="btn btn-primary">revert to this version</button>'
        );
        this.refreshView();
      }
      /**
       * @function _handler
       */
      function _handler() {
        const raw_body = component.raw_body_label(component.node);
        $("#file-history-revert").off("click", _handler);
        that.close();
        session.doc.setValue(restore_point[raw_body]);
        CodeEditor.Main.fileSaveHandler();
        let interval = setInterval(function() {
          if (restore_point[raw_body] !== session.getValue()) {
            CodeEditor.Main.fileSaveHandler();
          } else {
            clearInterval(interval);
          }
        }, 2);
      }
      if (restore_point) {
        $("#file-history-revert").on("click", _handler);
      }
    };
    return this;
  };
  this.component._checkEditorVlaue = (newValue, onFalseCallback) => {
    let timeout = setTimeout(function() {
      if (newValue != session.getValue) {
        console.warn("editor didn't update! ");
        return true;
      }
    }, 3000);
    let interval = setInterval(function() {
      if (newValue !== session.getValue()) {
        if (onFalseCallback === "function") {
          onFalseCallback();
        }
      } else {
        clearTimeout(timeout);
        clearInterval(interval);
        return true;
      }
    }, 2);
  };
  this.component.close = () => {
    if (editor && $(".ace_editor").length > 0) {
      if (editor.session) {
        if (diff.session) {
          diff.removeMarkers();
        }
        if (component.tab) {
          session.setValue(session.originalBody);
        }
      }
      CodeEditor.Main.enableEditor();
      CodeEditor.Main.fileSaveHandler();
    }
    if ($("#file-history").length > 0) {
      // $("#slider").slider("destroy")
      Mousetrap($("#file-history")[0]).unbind(["esc", "escape"]);
      $("#file-history").remove();
    }
    // console.console.warn(diffFiles.removeMarkers);
    if (asyncPending || component.async) {
      JSONData.abort();
      console.log("JSON aborted");
    }

    $(".editor-wrapper").css("height", "100vh");
    Panes.updateSize();
  };
  this.component.reinstance = node => {
    this.close();
    this.init(node);
  };

  this.component.isActive = () => $("#file-history").length > 0;
  this.component.raw_body_label = node => {
    let ext = node.data.path.split(".").last();
    if (ext === "liquid" || !node.data.tephra) {
      return "raw_body";
    } else if (ext === "scss") {
      return "raw_body_css";
    }
    return "raw_body_" + ext;
  };

  return this.component;
}
